import React, { useState, useEffect, useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config.js';
import { IconButton } from '@mui/material';
import {VisibilityIcon, VisibilityOffIcon} from '../../../assets/icons/icons';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function UserManagementDialog(props) {
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError, notificationWarning } = useNotification();
    const regexEmailValidator    = /^[a-z0-9]+([.\-_]?[a-z0-9]+)+@[a-z0-9]+([.\-_]?[a-z0-9]+)+\.[a-z]{2,}$/;
    const regexPassword = /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ]{14,256}$/

    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cityList, setCityList] = useState([]);
    const [role, setRole] = useState(null);
    
    const [cities, setCities] = useState([]);

    useEffect(() => {
        if(props.openUserManagementDialog === 'mod'){
            setNome(props?.lastCellData?.nome || '');
            setCognome(props?.lastCellData?.cognome || '');
            //setAdmin(props?.lastCellData?.admin === 'Y' ? true : false);
            setPassword('');
            setEmail(props?.lastCellData?.email);
            setShowPassword(false);
            setRole(props?.lastCellData?.role || '');
            setCityList(config.AVAILABLE_CITIES.filter(el => props?.lastCellData?.city.includes(el.id)))
        }else{
            setNome('');
            setCognome('');
            //setAdmin(false);
            setPassword('');
            setEmail('');
            setShowPassword(false);
            setRole(null);
            setCityList([]);
        }
        setCities(config.AVAILABLE_CITIES)
    },[props.openUserManagementDialog])

    const addUser = async() => {
        try {
            if(!regexEmailValidator.test(email) || !regexPassword.test(password) ){
                notificationWarning('Email o Password non validi');
                return;
            }
            const data = {
                attributes: [
                    {
                        "Name": 'name',
                        "Value": nome
                    },
                    {
                        "Name": 'family_name',
                        "Value": cognome
                    },
                    {
                        "Name": 'profile',
                        "Value": role
                    },
                    {
                        "Name": "email",
                        "Value": email
                    },
                    {
                        "Name": "email_verified",
                        "Value": 'true'
                    },
                    {
                        "Name": "zoneinfo",
                        "Value": cityList.map(el=>el.id).join(',')
                    }
                ],
                ps: password 
            }

            const axiosParams = {
                url: '/ins-user',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: data
            };

            await axios(axiosParams);
            notificationSuccess('Utente aggiunto con successo');
            await props.getUsers();
            props.handleCloseUserManagementDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const modUser = async() => {
        try {
            if(password){ 
                if( !regexPassword.test(password)){ 
                    notificationWarning('Password non valida');
                    return;
                }
            }
            const data = {
                userSub: props.lastCellData.sub,
                attributes: [
                    {
                        "Name": 'name',
                        "Value": nome
                    },
                    {
                        "Name": 'family_name',
                        "Value": cognome
                    },
                    {
                        "Name": 'profile',
                        "Value": role
                    },
                    {
                        "Name": "zoneinfo",
                        "Value": cityList.map(el=>el.id).join(',')
                    }
                ],
                ps: password 
            }

            const axiosParams = {
                url: '/mod-user',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: data
            };

            await axios(axiosParams);
            notificationSuccess(`Utente Aggiornato ${password ? 'e password aggiornata' : ''}`);
            await props.getUsers();
            props.handleCloseUserManagementDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    return (
        <Dialog className="dialog-mod-user" open={props.openUserManagementDialog} onClose={props.handleCloseUserManagementDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openUserManagementDialog === 'ins' ? 'Inserisci un nuovo utente' : 'Modifica utente'}</DialogTitle>
            <DialogContent>
                <div className='dialog-user-wrapper'>
                    <div className='dialog-user-wrapper-fields'>
                        <div className="dialog-user-fields">
                            <TextField
                                className="dialog-nome required-field-bg"
                                id="dialog-nome"
                                label="Nome"
                                type="text"
                                value={nome}
                                onChange={(event) => {
                                    setNome(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                            />
                            <TextField
                                className="dialog-cognome required-field-bg"
                                id="dialog-cognome"
                                label="Cognome"
                                type="text"
                                value={cognome}
                                onChange={(event) => {
                                    setCognome(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                            />
                        </div>
                        <div className="dialog-user-fields">
                            <TextField
                                className="dialog-email required-field-bg"
                                id="dialog-email"
                                label="Email"
                                type="text"
                                value={email}
                                disabled={props.openUserManagementDialog==='mod'}
                                onChange={(event) => {
                                    setEmail(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                            />
                            <div style={{
                                        width: "100%",
                                        position: 'relative'
                                    }}>
                                <TextField
                                    className="dialog-password required-field-bg"
                                    id="dialog-password"
                                    label="Password"
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(event) => {
                                        setPassword(event.target.value);
                                    }}
                                    variant="standard"
                                    style={{
                                        width: "100%",
                                    }}
                                    slotProps={{
                                        input:{
                                            endAdornment: showPassword ? <IconButton size='small' onClick={() => setShowPassword(!showPassword)}><VisibilityOffIcon addClass='pointer'/></IconButton> : <IconButton size='small' onClick={() => setShowPassword(!showPassword)}><VisibilityIcon addClass='pointer'/></IconButton>
                                        }
                                    }}
                                />
                                <div className='password-info' style={{paddingTop: '5px'}}>
                                        <span className={password.length>=14 ? 'green-txt' : 'red-txt'}>Minimo 14 caratteri e deve contenere almeno: </span>
                                        <div className='password-info-group'>
                                            <span className={/[a-z]/.test(password) ? 'green-txt' : 'red-txt'}>1 Carattere maiuscolo</span>
                                            <span className={/[A-Z]/.test(password) ? 'green-txt' : 'red-txt'}>1 Carattere minuscolo</span>
                                            <span className={/\d/.test(password) ? 'green-txt' : 'red-txt'}>1 Numero</span>
                                            <span className={/[\^$*.[\]{}()?"!@#%&\/,><\\':;|_~`=+-]/.test(password) ? 'green-txt' : 'red-txt'}>1 Carattere speciale</span>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    <div className='dialog-user-fields'>
                        <FormControl style={{width: "100%"}} variant='standard'>
                            <InputLabel id="select-role-label">Ruolo</InputLabel>
                            <Select
                                labelId="select-role-label"
                                id="select-role"
                                value={role}
                                label="Ruolo"
                                onChange={(event) => setRole(event.target.value)}
                            >
                                <MenuItem value={'A'}>Admin</MenuItem>
                                <MenuItem value={'E'}>Editor</MenuItem>
                                <MenuItem value={'M'}>Monitoring</MenuItem>
                                <MenuItem value={'MU'}>Municipalità</MenuItem>
                            </Select>
                        </FormControl>

                        <Autocomplete
                            className="cities-autocomplete"
                            multiple
                            style={{width: "100%"}}
                            options={cities}
                            disableCloseOnSelect
                            value={cityList}
                            onChange={(event, newValue) => {
                                setCityList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            //style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="cities-autocomplete-textfield"
                                    {...params}
                                    label="Città"
                                    variant="standard"
                                />
                            )}
                        />
                    </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={props.openUserManagementDialog === 'ins' ? () => addUser() : () => modUser()}>
                    {props.openUserManagementDialog === 'ins' ? 'Crea' : 'Modifica'}
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseUserManagementDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UserManagementDialog